import { FormattedMessage } from 'react-intl'
import { useAppSelector } from 'universal-scripts'
import Popover from '@components/Popover/Popover'
import AvatarPlaceholder from '@components/AvatarPlaceholder/AvatarPlaceholder'

import './UserMenu.css'

export default function UserMenu() {
  const user = useAppSelector((state) => state.user)
  const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen)
  const userName = user?.name || user?.email

  const handleLogout = () => {
    window.location.assign('/logout')
  }

  return (
    <Popover
      position="right"
      popoverClassName="popover-menu"
      buttonClassName="user-menu"
      triggerContent={
        <>
          <AvatarPlaceholder text={userName} />
          {isSidebarOpen && (
            <span title={userName} className="ellipsis">
              {userName}
            </span>
          )}
        </>
      }
    >
      <button type="button" className="logout-button" onClick={handleLogout}>
        <span className="icon icon-logout" />
        <span>
          <FormattedMessage id="logout" />
        </span>
      </button>
    </Popover>
  )
}
